import { useEffect, useRef, useState } from "react";
import Attribution from "ol/control/Attribution";
import ConstrainedView from "../views/ConstrainedView";
import olMap from "ol/Map";

type UseOlMapOptions = {
  view: ConstrainedView;
};

export function useOlMap({ view }: UseOlMapOptions) {
  const mapRef = useRef<HTMLDivElement>(null);
  const [map, setMap] = useState<olMap | null>(null);

  const viewRef = useRef(view);
  useEffect(() => {
    viewRef.current = view;

    if (map) {
      map.setView(view);
    }
  }, [view, map]);

  useEffect(() => {
    if (!mapRef.current) return;

    const attribution = new Attribution({ collapsible: false });

    const mapObject = new olMap({
      view: viewRef.current,
      layers: [],
      controls: [attribution],
      overlays: [],
    });

    mapObject.setTarget(mapRef.current);
    setMap(mapObject);

    return () => {
      mapObject.setTarget(undefined);
      setMap(null);
    };
  }, []);

  return { mapRef, map };
}
